import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { signInWithPhoneNumber } from "utils/auth";

export const requestOtp = createAsyncThunk(
  "requestOtp",
  async (info:any, thunkAPI) => {
    const maxRetries = 3; // Maximum number of retries
    let attempts = 0;
    const { dispatch } = thunkAPI;
    console.log(info,'------1------')
    while (attempts < maxRetries) {
      try {
        // Make the API call
        const { nextStep: signInNextStep } = await signInWithPhoneNumber(
          info
        );
        if (signInNextStep.signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE") {
          dispatch(setIsUserRegistered({ value: true }));
          return;
        } else if (signInNextStep.signInStep === "USER_NOT_REGISTERED") {
          dispatch(setIsUserRegistered({ value: false }));
          return thunkAPI.rejectWithValue("");
        } else {
          attempts += 1;
        }
      } catch (error) {
        attempts += 1;
        // If the maximum retries are reached, reject with an error
        console.error("Error signing in with phone number trying again", error);
        if (attempts >= maxRetries) {
          dispatch(setIsUserRegistered({ value: true }));
          return thunkAPI.rejectWithValue("Please try again");
        }
      }
    }
  }
);

const otpSlice = createSlice({
  name: "requestOtp",
  initialState: {
    loading: false,
    error: "",
    success: false,
    isUserRegistered: true,
  },
  reducers: {
    setIsUserRegistered: (state, action) => {
      state.isUserRegistered = action.payload.value;
    },
    resetAPIParams: (state) => {
      state.error = "";
      state.success = false;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(requestOtp.pending, (state) => {
      state.loading = true;
      state.error = "";
      state.success = false;
    });
    builder.addCase(requestOtp.fulfilled, (state) => {
      state.loading = false;
      state.success = true;
    });
    builder.addCase(requestOtp.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload as string;
    });
  },
});
export const { resetAPIParams, setIsUserRegistered } = otpSlice.actions;

export default otpSlice.reducer;
